import stringify from 'fast-json-stable-stringify';

import type {
  MutationType,
  QueryType,
} from '@web-platform/shared-universal-types/src/network/requestTypes';
import type { Variables } from '@web-platform/shared-universal-types/src/network/types';

export const getKey = (type: QueryType | MutationType, variables: Variables): string =>
  stringify({
    type,
    variables,
  });
